import clsx from "clsx";

export interface FilterChipOption {
  key: string;
  label: string;
}

interface FilterChipRowProps {
  options: FilterChipOption[];
  value: string;
  onChange: (key: string) => void;
  ariaLabel: string;
  className?: string;
}

export function FilterChipRow({
  options,
  value,
  onChange,
  ariaLabel,
  className,
}: FilterChipRowProps) {
  return (
    <div
      className={clsx("flex flex-wrap gap-2", className)}
      role="group"
      aria-label={ariaLabel}
    >
      {options.map((option) => {
        const active = value === option.key;
        return (
          <button
            key={option.key}
            type="button"
            onClick={() => onChange(option.key)}
            className={clsx(
              "min-h-[36px] rounded-full px-3.5 text-[13px] font-semibold transition-[background,color,border-color] duration-[var(--transition-base)]",
              active
                ? "border border-[var(--accent)] bg-[var(--accent-light)] text-[var(--accent)]"
                : "border border-[var(--border-subtle)] bg-[var(--surface-muted)] text-[var(--text-secondary)] hover:border-[rgba(215,15,100,0.22)] hover:text-[var(--text-primary)]"
            )}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
